import { Controller } from '@hotwired/stimulus';
import { debounce } from '../../utilities/debounce';

export default class extends Controller {
  private readonly RESIZE_DEBOUNCE_TIME = 300;
  private documentBody: HTMLElement = document.body;
  static readonly targets = ['element'];

  declare elementTarget: HTMLElement;

  private setPadding = () => {
    const position = window.getComputedStyle(this.elementTarget).position;
    if (position === 'fixed') {
      const offsetHeight = this.elementTarget.offsetHeight;
      this.documentBody.style.paddingBottom = `${offsetHeight}px`;
    } else {
      this.resetPadding();
    }
  };

  private resetPadding = () => {
    this.documentBody.style.paddingBottom = '0';
  };

  connect(): void {
    this.setPadding();
    window.addEventListener(
      'resize',
      debounce(this.setPadding, this.RESIZE_DEBOUNCE_TIME),
    );
  }

  disconnect(): void {
    this.resetPadding();
    window.removeEventListener(
      'resize',
      debounce(this.setPadding, this.RESIZE_DEBOUNCE_TIME),
    );
  }
}
